
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useApi from "../../../CustomHooks/useApi";
import { useSelector } from "react-redux";

const SettlementRemitterSoliteck = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // 1. EXTRACT BASIC DATA PASSED FROM LOGIN COMPONENT
    const remitter_mobile = location.state?.mobile || "";
    const remitter_name = location.state?.name || "Customer";
    const availableLimit = location.state?.availableLimit || "0";

    // const onetimelimit = useSelector((store) => store?.auth?.employeeDetails?.oneTimeLimit);
    const username = useSelector((state) => state.auth.employeeDetails?.username);

    // 2. INITIALIZE STATES (Start with empty list, will fetch from API)
    const [beneficiaries, setBeneficiaries] = useState([]);
    
    const [customerDetails, setCustomerDetails] = useState({
        name: remitter_name,
        mobile: remitter_mobile,
        limit: availableLimit
    });

    const [beneid, setBeniId] = useState("");
    const [selectedModes, setSelectedModes] = useState({});
    const [amounts, setAmounts] = useState({});
    const [error, setError] = useState("");
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedCheckbox, setSelectedCheckbox] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    // APIs
    const { callApi: loginRemitter } = useApi("/soliteck/remitter/login", "GET"); 
    const { callApi: deletebene } = useApi("/soliteck/bene/delete", "POST"); 

    // 3. FETCH DATA ON MOUNT & WHEN RETURNING FROM ADD BENE SCREEN
    useEffect(() => {
        if (remitter_mobile) {
            fetchBeneficiaries();
        }
        // Listening to location.key ensures it refetches if the user navigates back to this screen
    }, [remitter_mobile, location.key, location.state?.fetchbeneficiares]);

    const fetchBeneficiaries = async () => {
        setLoading(true);
        try {
            // Call the login API strictly with the mobile number to get the fresh list
            const res = await loginRemitter(null, `?remitterMobile=${remitter_mobile}`);
            
            // Safely grab the correct array from the response
            const listToMap = res?.beneficiaryList?.length > 0 
                ? res.beneficiaryList 
                : (res?.allBeneficiaryList || []);

            const refreshedList = listToMap.map(b => ({
                beneficiaryName: b.BeneName || b.beneName,
                bankName: b.BeneBank || b.bankName,
                accountNo: b.BeneAccount || b.beneAccount,
                ifscCode: b.BeneIFSC || b.beneIfsc,
                bene_id: b.BeneId || b.beneId,
                // verificationStatus: (b.IsValidate === "true" || b.isValidate === true) ? "APPROVED" : "Pending"
                verificationStatus: (b.IsActive === "true") ? "Active" : "Inactive"
            }));
            
            setBeneficiaries(refreshedList);

            // Update limit in case it changed
            if (res?.availableLimit) {
                setCustomerDetails(prev => ({ ...prev, limit: res.availableLimit }));
            }

        } catch (error) {
            console.error("Fetch beneficiaries failed:", error);
        } finally {
            setLoading(false);
        }
    };

    const hasValidAmount = (index) => {
        const val = amounts[index];
        // return val && Number(val) >= 5000;
        return val && Number(val) >= 5000;
    };

    useEffect(() => {
        if (beneficiaries.length > 0) {
            const defaultModes = {};
            beneficiaries.forEach((_, index) => {
                defaultModes[index] = "IMPS";
            });
            setSelectedModes(defaultModes);
        }
    }, [beneficiaries]);

    const handleCheckboxChange = (index) => {
        setError("");

        if (index === selectedCheckbox) {
            setSelectedCheckbox(null);
            setAmounts((prev) => ({ ...prev, [index]: "" }));
            setSelectedModes((prev) => ({ ...prev, [index]: "" }));
            setSelectedRows([]);
            return;
        }

        setSelectedCheckbox(index);
        setSelectedModes((prev) => ({ ...prev, [index]: "IMPS" }));

        setSelectedRows([
            {
                index,
                ...beneficiaries[index],
                amount: amounts[index] || "",
                mode: "IMPS",
            },
        ]);
    };

    const handleDeleteBeneficiary = async () => {
        if (selectedCheckbox === null) return;

        setDeleteLoading(true);
        setError("");

        try {
            const selectedBeneficiary = beneficiaries[selectedCheckbox];

            const response = await deletebene(
                null,
                `?beneId=${selectedBeneficiary.bene_id || selectedBeneficiary.beneficiaryId}&remitterMobile=${remitter_mobile}`
            );

            if (response && (response.status === "SUCCESS" || response.status_code === 200)) {
                // Remove from UI instantly
                setBeneficiaries(prev => prev.filter((_, i) => i !== selectedCheckbox));
                
                setSelectedCheckbox(null);
                setSelectedRows([]);
                setAmounts({});
                setSelectedModes({});
                setShowDeletePopup(false);
            } else {
                throw new Error(response?.message || "Delete failed");
            }
        } catch (error) {
            console.error("Delete beneficiary failed:", error);
            setError(error.message || "Something went wrong while deleting. Please try again.");
            setShowDeletePopup(false);
        } finally {
            setDeleteLoading(false);
        }
    };

    const handleDeleteClick = (beniid) => {
        if (selectedCheckbox !== null) {
            setBeniId(beniid);
            setShowDeletePopup(true);
        }
    };

    const handleCancelDelete = () => {
        setShowDeletePopup(false);
    };

    const handleModeChange = (index, mode) => {
        setSelectedModes((prev) => {
            const updatedModes = { ...prev, [index]: mode };
            if (index === selectedCheckbox) {
                setSelectedRows([
                    {
                        index,
                        ...beneficiaries[index],
                        amount: amounts[index] || "",
                        mode: mode,
                    },
                ]);
            }
            return updatedModes;
        });
    };

    const handleAmountChange = (index, value) => {
        // if (parseFloat(value) < 5000) {
        if (parseFloat(value) < 5000) {
            setError("Please enter an amount greater than or equal to 5000.");
        // } else if (parseFloat(value) > onetimelimit) {
        //     setError(`Please enter an amount less than or equal to ${onetimelimit}`);
        // } else {
            } else if (parseFloat(value) > Number(customerDetails.limit)) {
            setError(`Please enter an amount less than or equal to ${customerDetails.limit}`);
        } else {
            setError("");
        }

        setAmounts((prev) => {
            const updatedAmounts = { ...prev, [index]: value };
            if (index === selectedCheckbox) {
                setSelectedRows([
                    {
                        index,
                        ...beneficiaries[index],
                        amount: value,
                        mode: selectedModes[index] || "",
                    },
                ]);
            }
            return updatedAmounts;
        });
    }

    const handleAddNewClick = () => {
        navigate("/addbeneimps2", {
            state: {
                mobile: customerDetails.mobile,
                name: customerDetails.name,
            },
        });
    };

    const handleProcess = async () => {
        if (selectedCheckbox === null) {
            setError("Please select a beneficiary first!");
            return;
        }

        const selectedMode = selectedModes[selectedCheckbox];
        const selectedAmount = amounts[selectedCheckbox];

        if (!selectedAmount) {
            setError("Please enter an amount before proceeding.");
            return;
        }

        // if (parseFloat(selectedAmount) > onetimelimit) {
        //     setError(`Please enter an amount less than or equal to ${onetimelimit}`);
        //     return;
        // }
        if (parseFloat(selectedAmount) > Number(customerDetails.limit)) {
            setError(`Please enter an amount less than or equal to ${customerDetails.limit}`);
            return;
        }
        // if (parseFloat(selectedAmount) < 5000) {
        if (parseFloat(selectedAmount) < 5000) {
            setError("Amount must be at least 5000.");
            return;
        }

        if (!selectedMode) {
            setError("Please select a mode before proceeding.");
            return;
        }

        setError("");
        navigate("/settlementimps2fundtransfer", {
            state: {
                selectedBeneficiary: selectedRows.map(row => ({
                    ...row,
                    bene_id: row.bene_id,
                    remitterMobileNumber: remitter_mobile // Passing this so it can be used as customerMobile in Payout API
                })),
                amount: selectedAmount,
            },
        });
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10">
            <div className="max-w-[100%] mx-auto px-4 space-y-8">
                {/* ===== HEADER / REMITTER DETAILS ===== */}
                <div className="px-3 sm:px-6 bg-white/90 backdrop-blur-xl rounded-2xl border shadow-lg py-4 flex flex-col sm:flex-row gap-4 items-center justify-between">
                    
                    {/* LEFT: NAME | MOBILE | LIMIT */}
                    <div className="gap-2 text-[16px] sm:text-xl flex flex-wrap items-center font-bold text-slate-800">
                        <span className="text-slate-800">{customerDetails.name}</span>
                        <span className="text-slate-400">|</span>
                        <span className="text-indigo-600">{customerDetails.mobile}</span>
                        <span className="text-slate-400">|</span>
                        <span className="text-emerald-600 text-sm sm:text-lg bg-emerald-50 px-3 py-1 rounded-lg">
                            Limit: ₹{customerDetails.limit}
                        </span>
                    </div>

                    {/* RIGHT: ACTION BUTTON */}
                    <button
                        onClick={handleAddNewClick}
                        className="px-4 py-2 text-sm font-semibold bg-[#12345A] hover:bg-[#0F2E47] text-white rounded-lg shadow hover:shadow-md transition"
                    >
                        + Add Beneficiary
                    </button>
                </div>

                {/* ================= BENEFICIARIES ================= */}
                {error && <p className="text-rose-600 text-sm font-bold bg-rose-50 px-4 py-2 rounded-lg border border-rose-200">{error}</p>}
                
                <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">
                    {/* ================= MOBILE VIEW ================= */}
                    <div className="block md:hidden space-y-4 p-4">
                        {loading ? (
                            <p className="text-center text-slate-500 py-10">Loading beneficiaries…</p>
                        ) : beneficiaries.length === 0 ? (
                            <p className="text-center text-slate-500 py-10">No beneficiaries found</p>
                        ) : (
                            beneficiaries.map((item, index) => (
                                <div
                                    key={index}
                                    className={`rounded-2xl border p-4 space-y-3 ${selectedCheckbox === index ? "border-indigo-500 bg-indigo-50" : "border-slate-200 bg-white"}`}
                                >
                                    {/* HEADER */}
                                    <div className="flex items-center justify-between">
                                        <label className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                checked={selectedCheckbox === index}
                                                onChange={() => handleCheckboxChange(index)}
                                            />
                                            <span className={selectedCheckbox === index ? "font-bold text-red-600" : "font-semibold text-slate-800"}>
                                                {item.beneficiaryName}
                                            </span>
                                        </label>

                                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${item.verificationStatus === "APPROVED" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>
                                            {item.verificationStatus}
                                        </span>
                                    </div>

                                    {/* DETAILS */}
                                    <div className="text-sm text-slate-600 space-y-1">
                                        <p><b>Bank:</b> {item.bankName}</p>
                                        <p><b>Account:</b> <span className={selectedCheckbox === index ? "font-bold text-red-600" : "font-semibold text-slate-600"}>{item.accountNo}</span></p>
                                        <p><b>IFSC:</b> {item.ifscCode}</p>
                                    </div>

                                    {/* MODE */}
                                    <label className="flex items-center gap-2">
                                        <input type="radio" checked={true} disabled={selectedCheckbox !== index} readOnly />
                                        IMPS
                                    </label>

                                    {/* AMOUNT */}
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        placeholder="Enter Amount"
                                        value={amounts[index] || ""}
                                        disabled={selectedCheckbox !== index}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (/^\d{0,6}$/.test(val)) handleAmountChange(index, val);
                                        }}
                                        className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:border-indigo-500 outline-none font-bold"
                                    />

                                    {hasValidAmount(index) ? (
                                        <button
                                            onClick={handleProcess}
                                            disabled={selectedCheckbox !== index}
                                            className={`w-full py-3 rounded-xl text-sm font-semibold ${selectedCheckbox === index ? "bg-indigo-600 text-white shadow-md" : "bg-slate-200 text-slate-400"}`}
                                        >
                                            Fund Transfer
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => handleDeleteClick(item.bene_id || item.beneficiaryId)}
                                            disabled={selectedCheckbox !== index}
                                            className={`w-full py-3 rounded-xl text-sm font-semibold ${selectedCheckbox === index ? "bg-rose-500 text-white shadow-md" : "bg-slate-200 text-slate-400"}`}
                                        >
                                            Delete Beneficiary
                                        </button>
                                    )}
                                </div>
                            ))
                        )}

                        <button
                            onClick={handleProcess}
                            className="w-full py-4 rounded-2xl bg-[#12345A] text-white shadow-lg font-bold"
                        >
                            Proceed
                        </button>
                    </div>

                    {/* ================= DESKTOP VIEW ================= */}
                    <div className="hidden md:block overflow-x-auto">
                        <div className="rounded-xl border border-gray-400 bg-white shadow-sm">
                            <table className="w-full text-sm 2xl:text-base min-[2000px]:text-[22px] text-left border-collapse">
                                <thead className="bg-[#12345A] text-white">
                                    <tr>
                                        {["Select", "Mode", "Name", "Bank", "Account", "IFSC", "Status", "Amount", "Action"].map((h) => (
                                            <th key={h} className="px-4 py-3 font-semibold border border-gray-400">{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-200">
                                    {loading ? (
                                        <tr>
                                            <td colSpan="9" className="py-10 text-center text-slate-500 font-medium">Loading beneficiaries…</td>
                                        </tr>
                                    ) : beneficiaries.length === 0 ? (
                                        <tr>
                                            <td colSpan="9" className="py-10 text-center text-slate-500 font-medium">No beneficiaries found</td>
                                        </tr>
                                    ) : (
                                        beneficiaries.map((item, index) => (
                                            <tr key={index} className={`hover:bg-slate-50 transition ${selectedCheckbox === index ? "bg-indigo-50/60" : ""}`}>
                                                <td className="px-4 py-3 border border-gray-300">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedCheckbox === index}
                                                        onChange={() => handleCheckboxChange(index)}
                                                        className="w-4 min-[2000px]:w-6 h-4 min-[2000px]:h-6 cursor-pointer accent-blue-600"
                                                    />
                                                </td>
                                                <td className="px-4 py-3 border border-gray-300">
                                                    <label className="flex items-center gap-2">
                                                        <input type="radio" checked={true} disabled={selectedCheckbox !== index} readOnly />
                                                        IMPS
                                                    </label>
                                                </td>
                                                <td className={`px-4 py-3 border border-gray-300 ${selectedCheckbox === index ? "font-bold text-red-600" : "font-semibold text-slate-700"}`}>
                                                    {item.beneficiaryName}
                                                </td>
                                                <td className="px-4 py-3 border font-semibold border-gray-300 text-slate-700">{item.bankName}</td>
                                                <td className={`px-4 py-3 border border-gray-300 ${selectedCheckbox === index ? "font-bold text-red-600" : "font-semibold text-slate-700"}`}>
                                                    {item.accountNo}
                                                </td>
                                                <td className={`px-4 py-3 border border-gray-300 ${selectedCheckbox === index ? "font-bold text-slate-900" : "font-semibold text-slate-600"}`}>
                                                    {item.ifscCode}
                                                </td>
                                                <td className="px-4 py-3 border border-gray-300">
                                                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${item.verificationStatus === "APPROVED" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>
                                                        {item.verificationStatus}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3 border border-gray-300">
                                                    <input
                                                        type="text"
                                                        inputMode="numeric"
                                                        placeholder="₹ Amount"
                                                        value={amounts[index] || ""}
                                                        disabled={selectedCheckbox !== index}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^\d{0,6}$/.test(val)) handleAmountChange(index, val);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                if (selectedCheckbox === index && hasValidAmount(index)) {
                                                                    handleProcess();
                                                                }
                                                            }
                                                        }}
                                                        className="w-full px-3 py-2 rounded-lg border font-bold border-slate-300 focus:border-[#12345A] focus:outline-none"
                                                    />
                                                </td>
                                                <td className="px-4 py-3 border border-gray-300">
                                                    {hasValidAmount(index) ? (
                                                        <button
                                                            onClick={handleProcess}
                                                            disabled={selectedCheckbox !== index}
                                                            className={`px-4 py-2 rounded-lg text-xs font-bold w-full shadow-sm
                                                                ${selectedCheckbox === index ? "bg-[#12345A] text-white hover:bg-[#0F2E47]" : "bg-slate-200 text-slate-400"}`}
                                                        >
                                                            Fund Transfer
                                                        </button>
                                                    ) : (
                                                        <button
                                                            onClick={() => handleDeleteClick(item.bene_id || item.beneficiaryId)}
                                                            disabled={selectedCheckbox !== index}
                                                            className={`px-4 py-2 rounded-lg text-xs font-bold w-full shadow-sm
                                                                ${selectedCheckbox === index ? "bg-rose-500 text-white hover:bg-rose-600" : "bg-slate-200 text-slate-400"}`}
                                                        >
                                                            Delete
                                                        </button>
                                                        
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>

            {/* DELETE CONFIRMATION POPUP */}
            {showDeletePopup && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl">
                        <h3 className="text-xl font-bold text-slate-800 mb-3">Confirm Delete</h3>
                        <p className="text-slate-600 mb-6 text-sm sm:text-base">
                            Are you sure you want to delete
                            <span className="block font-bold text-lg text-slate-900 mt-1">
                                {beneficiaries[selectedCheckbox]?.beneficiaryName}
                            </span>
                        </p>

                        <div className="flex justify-end gap-3">
                            <button
                                onClick={handleCancelDelete}
                                disabled={deleteLoading}
                                className="px-5 py-3 rounded-xl bg-slate-100 text-slate-700 font-bold hover:bg-slate-200 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDeleteBeneficiary}
                                disabled={deleteLoading}
                                className="px-5 py-3 rounded-xl bg-rose-500 text-white font-bold hover:bg-rose-600 transition flex items-center gap-2"
                            >
                                {deleteLoading ? "Deleting..." : "Confirm Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SettlementRemitterSoliteck;